import React from 'react';

import { OutlinedButton } from '@/components/styledComponents';

import './_shortcutsModal.scss';

const OldShortcutComponent = ({ keysData, title, onClose }) => {
  return (
    <div className="old-shortcuts-modal">
      <h3 className="old-shortcuts-modal-heading">{title}</h3>
      <div className="old-shortcuts-table">
        {keysData.map((item, index) => (
          <div key={index} className="old-shortcuts-item">
            <div className="old-shortcut-item-title-section">
              <div className="old-shortcuts-icon">{item.icon}</div>
              <div className="old-shortcuts-title">{item.title}</div>
            </div>
            <div className="old-shortcuts-keys-section">
              {item.keys.map((key) => {
                return (
                  <span className="old-shortcut-key" key={key}>
                    {key}
                  </span>
                );
              })}
            </div>
          </div>
        ))}
      </div>
      <div className="close-button-wrapper">
        <OutlinedButton
          width="100%"
          size="modal"
          borderColor="var(--icon-default)"
          color="var(--text-subdued)"
          onClick={onClose}
          fontWeight={400}>
          Close
        </OutlinedButton>
      </div>
    </div>
  );
};

export default OldShortcutComponent;
